(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-creators"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SITE = {
      businessEmail: '',
      emailLabel: 'Business email to be confirmed',
    };

    var arrowSvg = '<svg class="arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>';

    function showToast(message) {
      var toast = document.querySelector('.toast');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(window.__toastTimer);
      window.__toastTimer = setTimeout(function () {
        toast.classList.remove('show');
      }, 3200);
    }

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard
          .writeText(text)
          .then(function () {
            return true;
          })
          .catch(function () {
            return fallbackCopy(text);
          });
      }
      return Promise.resolve(fallbackCopy(text));
    }

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      var ok = document.execCommand('copy');
      textarea.remove();
      return ok;
    }

    function initMailButtons() {
      document.querySelectorAll('[data-email-label]').forEach(function (el) {
        el.textContent = SITE.businessEmail || SITE.emailLabel;
      });

      document.querySelectorAll('.js-mail').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var subject = button.dataset.subject || '[Creator Partnership] Name | Platform';
          if (SITE.businessEmail) {
            window.location.href = 'mailto:' + SITE.businessEmail + '?subject=' + encodeURIComponent(subject);
            return;
          }
          copyText(subject).then(function () {
            showToast('The business email is not configured yet. The suggested subject has been copied.');
          });
        });
      });

      document.querySelectorAll('.js-copy-subject').forEach(function (button) {
        button.addEventListener('click', function () {
          copyText(button.dataset.subject || '').then(function () {
            showToast('Suggested email subject copied.');
          });
        });
      });
    }

    function initFaq(prefix) {
      document.querySelectorAll('.faq-question').forEach(function (button, index) {
        var answer = button.nextElementSibling;
        var id = 'faq-answer-' + prefix + '-' + (index + 1);
        answer.id = id;
        button.setAttribute('aria-controls', id);
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', function () {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
        });
      });
    }

    function initReveal() {
      var items = document.querySelectorAll('.reveal');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('visible');
        });
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08 }
      );
      items.forEach(function (item) {
        observer.observe(item);
      });
    }

    function init() {
      initMailButtons();
      initFaq('ac');
      initReveal();
      document.querySelectorAll('.button.with-arrow').forEach(function (button) {
        if (!button.querySelector('svg')) {
          button.insertAdjacentHTML('beforeend', arrowSvg);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-home"] && !Shopify.designMode) return;
  try {
    
  (async () => {
    const TOKEN = '20d849c7cd3c523bb8699e5333fe79bf';
    const BLOG = 'ume-all-posts';
    const API = '/api/2024-04/graphql.json';
    const perPage = parseInt(document.getElementById('latest').dataset.perPage) || 9;

    const search = document.getElementById('article-search');
    const grid = document.getElementById('article-grid');
    const resultCount = document.getElementById('result-count');
    const noResults = document.getElementById('no-results');
    const clearButton = document.getElementById('clear-filters');
    const pagination = document.getElementById('pagination');
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // Fetch all articles via Storefront GraphQL API
    let articles = [];
    let cursor = null,
      hasNext = true;
    while (hasNext) {
      const after = cursor ? `,after:"${cursor}"` : '';
      const q = `{blog(handle:"${BLOG}"){articles(first:250${after}){edges{node{title,handle,image{url,altText},tags,publishedAt,contentHtml,excerpt},cursor},pageInfo{hasNextPage,endCursor}}}}`;
      const res = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
        body: JSON.stringify({ query: q }),
      });
      const json = await res.json();
      if (!json.data || !json.data.blog) break;
      const { edges, pageInfo } = json.data.blog.articles;
      edges.forEach((e) => {
        const n = e.node;
        articles.push({
          title: n.title,
          url: `/blogs/${BLOG}/${n.handle}`,
          image: n.image ? n.image.url : '',
          image_alt: n.image ? n.image.altText || n.title : '',
          tags: n.tags || [],
          published_at: n.publishedAt,
          content_length: n.contentHtml
            ? n.contentHtml
                .replace(/<[^>]*>/g, '')
                .split(/\s+/)
                .filter((w) => w).length
            : 0,
          excerpt: n.excerpt || '',
        });
      });
      hasNext = pageInfo.hasNextPage;
      cursor = pageInfo.endCursor;
    }

    // Loading complete
    document.getElementById('loading-bar').hidden = true;

    // Sort by published date (newest first)
    articles.sort((a, b) => new Date(b.published_at) - new Date(a.published_at));

    // Build search index
    articles.forEach((a) => {
      a._search = (a.title + ' ' + a.tags.join(' ')).toLowerCase().replace(/-/g, ' ');
    });

    // Pagination state
    const urlParams = new URLSearchParams(window.location.search);
    const urlPage = parseInt(urlParams.get('page')) || 1;
    let currentPage = urlPage,
      isSearching = false;

    // Detect tag from URL path: /tagged/X
    const pathMatch = window.location.pathname.match(/\/tagged\/([^/?]+)/);
    if (pathMatch) search.value = decodeURIComponent(pathMatch[1]).replace(/-/g, ' ');

    // Helpers
    function fmtDate(iso) {
      const d = new Date(iso);
      return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    }

    function buildCard(a) {
      const ds = fmtDate(a.published_at);
      const rt = Math.max(1, Math.ceil((a.content_length || 0) / 200));
      const ft = a.tags.length > 0 ? a.tags[0] : '';
      const img = a.image
        ? `<img loading="lazy" src="${a.image}" alt="${(a.image_alt || a.title).replace(/"/g, '&quot;')}">`
        : '';
      const cat = ft ? `<span class="category">${ft}</span>` : '';
      const ex = (a.excerpt || a.title).split(/\s+/).slice(0, 20).join(' ');
      return `<a class="article-card reveal" href="${a.url}"><div class="card-media">${img}</div><div class="card-body"><div class="story-meta">${cat}<span>${ds}</span><span>${rt} min</span></div><h3>${a.title}</h3><p>${ex}</p><span class="card-arrow">Read article →</span></div></a>`;
    }

    function renderPagination(total) {
      const tp = Math.ceil(total / perPage);
      if (tp <= 1) {
        pagination.innerHTML = '';
        pagination.hidden = true;
        return;
      }
      pagination.hidden = false;
      let h = '';
      if (currentPage > 1) h += `<a class="page-link" data-page="${currentPage - 1}">\u2039</a>`;
      else h += '<span class="page-link is-disabled">\u2039</span>';
      for (let i = 1; i <= tp; i++) {
        if (i === currentPage) h += `<a class="page-link is-current">${i}</a>`;
        else if (i === 1 || i === tp || Math.abs(i - currentPage) <= 2)
          h += `<a class="page-link" data-page="${i}">${i}</a>`;
        else if (i === 2 || i === currentPage - 3 || i === currentPage + 3)
          h += '<span class="page-ellipsis">\u2026</span>';
      }
      if (currentPage < tp) h += `<a class="page-link" data-page="${currentPage + 1}">\u203a</a>`;
      else h += '<span class="page-link is-disabled">\u203a</span>';
      h += `<form class="page-jump"><label for="page-number">Go to</label><input id="page-number" name="page" type="number" min="1" max="${tp}" value="${currentPage}" inputmode="numeric"><button type="submit">Go</button></form>`;
      pagination.innerHTML = h;
    }

    function render() {
      const q = search.value.trim().toLowerCase();
      isSearching = !!q;
      const filtered = isSearching ? articles.filter((a) => a._search.includes(q)) : articles;
      const tp = Math.ceil(filtered.length / perPage);
      if (currentPage > tp) currentPage = tp || 1;
      const start = (currentPage - 1) * perPage;
      const pageItems = filtered.slice(start, start + perPage);
      grid.innerHTML = pageItems.map(buildCard).join('');

      if (isSearching) {
        resultCount.textContent = `${filtered.length} ${filtered.length === 1 ? 'article' : 'articles'} found`;
        noResults.hidden = filtered.length !== 0;
        grid.hidden = filtered.length === 0;
      } else {
        resultCount.textContent = `${pageItems.length} of ${articles.length} articles`;
        noResults.hidden = true;
        grid.hidden = articles.length === 0;
      }

      clearButton.hidden = !q;
      document.querySelector('.blog-home-section .featured').hidden = isSearching;
      document.querySelector('.blog-home-section .goal-section').hidden = isSearching;
      document.getElementById('search-clear').style.display = q ? 'flex' : 'none';
      renderPagination(filtered.length);
    }

    function updateUrl(p) {
      const u = new URL(window.location);
      if (p > 1) u.searchParams.set('page', p);
      else u.searchParams.delete('page');
      history.replaceState({}, '', u);
    }

    // Event listeners
    pagination.addEventListener('click', (e) => {
      const l = e.target.closest('[data-page]');
      if (l) {
        e.preventDefault();
        currentPage = parseInt(l.dataset.page);
        updateUrl(currentPage);
        render();
      }
    });

    pagination.addEventListener('submit', (e) => {
      if (e.target.classList.contains('page-jump')) {
        e.preventDefault();
        const p = parseInt(e.target.querySelector('input[name="page"]').value);
        const q = search.value.trim().toLowerCase();
        const filtered = q ? articles.filter((a) => a._search.includes(q)) : articles;
        const tp = Math.ceil(filtered.length / perPage);
        if (p >= 1 && p <= tp) {
          currentPage = p;
          updateUrl(currentPage);
          render();
        }
      }
    });

    search.addEventListener('input', () => {
      currentPage = 1;
      if (!search.value.trim()) updateUrl(1);
      render();
    });

    function clearFilters() {
      search.value = '';
      currentPage = 1;
      updateUrl(1);
      render();
      search.focus();
    }
    clearButton.addEventListener('click', clearFilters);
    document.getElementById('no-results-clear').addEventListener('click', clearFilters);
    document.getElementById('search-clear').addEventListener('click', clearFilters);

    document.addEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        search.focus();
      }
    });

    document.querySelectorAll('.topic-chip').forEach((chip) => {
      chip.addEventListener('click', (e) => {
        e.preventDefault();
        search.value = chip.textContent.trim();
        currentPage = 1;
        updateUrl(1);
        render();
        search.focus();
      });
    });

    // Initial render
    render();
  })();

  // News / Tech Insights switch
  (() => {
    const resetTabs = () => {
      document.querySelectorAll('.whats-new-tab.is-switching').forEach((tab) => tab.classList.remove('is-switching'));
      document
        .querySelectorAll('[data-whats-new-tabs][aria-busy]')
        .forEach((group) => group.removeAttribute('aria-busy'));
    };
    window.addEventListener('pageshow', resetTabs);

    document.querySelectorAll('[data-whats-new-tabs]').forEach((group) => {
      if (group.dataset.tabsReady === 'true') return;
      group.dataset.tabsReady = 'true';

      const tabs = Array.from(group.querySelectorAll('.whats-new-tab'));
      const prefetched = new Set();

      const prefetch = (url) => {
        if (!url || prefetched.has(url)) return;
        prefetched.add(url);
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'document';
        link.href = url;
        document.head.appendChild(link);
      };

      tabs.forEach((tab) => {
        const warm = () => prefetch(tab.href);
        tab.addEventListener('pointerenter', warm, { once: true });
        tab.addEventListener('focus', warm, { once: true });

        tab.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
          const current = group.querySelector('.whats-new-tab[aria-current="page"]');
          if (current === tab) {
            event.preventDefault();
            return;
          }
          group.setAttribute('aria-busy', 'true');
          tab.classList.add('is-switching');
        });

        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const index = tabs.indexOf(tab);
          const nextIndex =
            event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          prefetch(tabs[nextIndex].href);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-news"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const resetTabs = () => {
      document.querySelectorAll('.whats-new-tab.is-switching').forEach((tab) => tab.classList.remove('is-switching'));
      document
        .querySelectorAll('[data-whats-new-tabs][aria-busy]')
        .forEach((group) => group.removeAttribute('aria-busy'));
    };
    window.addEventListener('pageshow', resetTabs);

    const tabsGroups = document.querySelectorAll('[data-whats-new-tabs]');

    tabsGroups.forEach((group) => {
      if (group.dataset.tabsReady === 'true') return;
      group.dataset.tabsReady = 'true';

      const tabs = Array.from(group.querySelectorAll('.whats-new-tab'));
      const prefetched = new Set();

      const prefetch = (url) => {
        if (!url || prefetched.has(url)) return;
        prefetched.add(url);
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'document';
        link.href = url;
        document.head.appendChild(link);
      };

      tabs.forEach((tab) => {
        const warm = () => prefetch(tab.href);
        tab.addEventListener('pointerenter', warm, { once: true });
        tab.addEventListener('focus', warm, { once: true });

        tab.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
          const current = group.querySelector('.whats-new-tab[aria-current="page"]');
          if (current === tab) {
            event.preventDefault();
            return;
          }
          group.setAttribute('aria-busy', 'true');
          tab.classList.add('is-switching');
        });

        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const index = tabs.indexOf(tab);
          const nextIndex =
            event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          prefetch(tabs[nextIndex].href);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReveal() {
      var items = document.querySelectorAll('.brand-story-section .reveal');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('visible');
        });
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08 }
      );
      items.forEach(function (item) {
        observer.observe(item);
      });
    }

    function init() {
      initReveal();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["business-cooperation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SITE = {
      businessEmail: '',
      emailLabel: 'Business email to be confirmed',
    };

    var arrowSvg = '<svg class="arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>';

    function showToast(message) {
      var toast = document.querySelector('.toast');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(window.__toastTimer);
      window.__toastTimer = setTimeout(function () {
        toast.classList.remove('show');
      }, 3200);
    }

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard
          .writeText(text)
          .then(function () {
            return true;
          })
          .catch(function () {
            return fallbackCopy(text);
          });
      }
      return Promise.resolve(fallbackCopy(text));
    }

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      var ok = document.execCommand('copy');
      textarea.remove();
      return ok;
    }

    function initMailButtons() {
      document.querySelectorAll('[data-email-label]').forEach(function (el) {
        el.textContent = SITE.businessEmail || SITE.emailLabel;
      });

      document.querySelectorAll('.js-mail').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var subject = button.dataset.subject || '[Business Partnership] Company | Market';
          if (SITE.businessEmail) {
            window.location.href = 'mailto:' + SITE.businessEmail + '?subject=' + encodeURIComponent(subject);
            return;
          }
          copyText(subject).then(function () {
            showToast('The business email is not configured yet. The suggested subject has been copied.');
          });
        });
      });

      document.querySelectorAll('.js-copy-subject').forEach(function (button) {
        button.addEventListener('click', function () {
          copyText(button.dataset.subject || '').then(function () {
            showToast('Suggested email subject copied.');
          });
        });
      });
    }

    function initFaq(prefix) {
      document.querySelectorAll('.faq-question').forEach(function (button, index) {
        var answer = button.nextElementSibling;
        var id = 'faq-answer-' + prefix + '-' + (index + 1);
        answer.id = id;
        button.setAttribute('aria-controls', id);
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', function () {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
        });
      });
    }

    function initReveal() {
      var items = document.querySelectorAll('.reveal');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('visible');
        });
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08 }
      );
      items.forEach(function (item) {
        observer.observe(item);
      });
    }

    function init() {
      initMailButtons();
      initFaq('bc');
      initReveal();
      document.querySelectorAll('.button.with-arrow').forEach(function (button) {
        if (!button.querySelector('svg')) {
          button.insertAdjacentHTML('beforeend', arrowSvg);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-solutions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SITE = {
      businessEmail: '',
      emailLabel: 'Business email to be confirmed',
    };

    var arrowSvg = '<svg class="arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>';

    function showToast(message) {
      var toast = document.querySelector('.toast');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(window.__toastTimer);
      window.__toastTimer = setTimeout(function () {
        toast.classList.remove('show');
      }, 3200);
    }

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard
          .writeText(text)
          .then(function () {
            return true;
          })
          .catch(function () {
            return fallbackCopy(text);
          });
      }
      return Promise.resolve(fallbackCopy(text));
    }

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      var ok = document.execCommand('copy');
      textarea.remove();
      return ok;
    }

    function initMailButtons() {
      document.querySelectorAll('[data-email-label]').forEach(function (el) {
        el.textContent = SITE.businessEmail || SITE.emailLabel;
      });

      document.querySelectorAll('.js-mail').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var subject = button.dataset.subject || '[Corporate & Custom] Company / Organization | Country';
          if (SITE.businessEmail) {
            window.location.href = 'mailto:' + SITE.businessEmail + '?subject=' + encodeURIComponent(subject);
            return;
          }
          copyText(subject).then(function () {
            showToast('The business email is not configured yet. The suggested subject has been copied.');
          });
        });
      });

      document.querySelectorAll('.js-copy-subject').forEach(function (button) {
        button.addEventListener('click', function () {
          copyText(button.dataset.subject || '').then(function () {
            showToast('Suggested email subject copied.');
          });
        });
      });
    }

    function initFaq(prefix) {
      document.querySelectorAll('.faq-question').forEach(function (button, index) {
        var answer = button.nextElementSibling;
        var id = 'faq-answer-' + prefix + '-' + (index + 1);
        answer.id = id;
        button.setAttribute('aria-controls', id);
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', function () {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
        });
      });
    }

    function initReveal() {
      var items = document.querySelectorAll('.reveal');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('visible');
        });
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08 }
      );
      items.forEach(function (item) {
        observer.observe(item);
      });
    }

    function init() {
      initMailButtons();
      initFaq('cs');
      initReveal();
      document.querySelectorAll('.button.with-arrow').forEach(function (button) {
        if (!button.querySelector('svg')) {
          button.insertAdjacentHTML('beforeend', arrowSvg);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distributors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SITE = {
      businessEmail: '',
      emailLabel: 'Business email to be confirmed',
    };

    var arrowSvg = '<svg class="arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>';

    function showToast(message) {
      var toast = document.querySelector('.toast');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(window.__toastTimer);
      window.__toastTimer = setTimeout(function () {
        toast.classList.remove('show');
      }, 3200);
    }

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard
          .writeText(text)
          .then(function () {
            return true;
          })
          .catch(function () {
            return fallbackCopy(text);
          });
      }
      return Promise.resolve(fallbackCopy(text));
    }

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      var ok = document.execCommand('copy');
      textarea.remove();
      return ok;
    }

    function initMailButtons() {
      document.querySelectorAll('[data-email-label]').forEach(function (el) {
        el.textContent = SITE.businessEmail || SITE.emailLabel;
      });

      document.querySelectorAll('.js-mail').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var subject = button.dataset.subject || '[Distribution] Company | Target Market';
          if (SITE.businessEmail) {
            window.location.href = 'mailto:' + SITE.businessEmail + '?subject=' + encodeURIComponent(subject);
            return;
          }
          copyText(subject).then(function () {
            showToast('The business email is not configured yet. The suggested subject has been copied.');
          });
        });
      });

      document.querySelectorAll('.js-copy-subject').forEach(function (button) {
        button.addEventListener('click', function () {
          copyText(button.dataset.subject || '').then(function () {
            showToast('Suggested email subject copied.');
          });
        });
      });
    }

    function initFaq(prefix) {
      document.querySelectorAll('.faq-question').forEach(function (button, index) {
        var answer = button.nextElementSibling;
        var id = 'faq-answer-' + prefix + '-' + (index + 1);
        answer.id = id;
        button.setAttribute('aria-controls', id);
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', function () {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
        });
      });
    }

    function initReveal() {
      var items = document.querySelectorAll('.reveal');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('visible');
        });
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08 }
      );
      items.forEach(function (item) {
        observer.observe(item);
      });
    }

    function init() {
      initMailButtons();
      initFaq('db');
      initReveal();
      document.querySelectorAll('.button.with-arrow').forEach(function (button) {
        if (!button.querySelector('svg')) {
          button.insertAdjacentHTML('beforeend', arrowSvg);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const productTabs = [...document.querySelectorAll('[role="tab"]')];
    const faqItems = [...document.querySelectorAll('.faq-item')];
    const faqButtons = [...document.querySelectorAll('.faq-question')];
    const filterChips = [...document.querySelectorAll('.filter-chip')];
    const searchInput = document.getElementById('faq-search');
    const resultsCount = document.getElementById('result-count');
    const noResults = document.getElementById('no-results');
    const clearFilters = document.getElementById('clear-filters');
    let activeCategory = 'all';

    faqItems.forEach((item) => {
      item.dataset.search = item.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    });

    function setFaqExpanded(button, expanded) {
      button.setAttribute('aria-expanded', String(expanded));
      document.getElementById(button.getAttribute('aria-controls')).hidden = !expanded;
    }

    faqButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const willExpand = button.getAttribute('aria-expanded') !== 'true';
        faqButtons.forEach((other) => setFaqExpanded(other, false));
        setFaqExpanded(button, willExpand);
      });
    });

    function applyFilters() {
      const query = searchInput.value.trim().toLowerCase();
      let visibleCount = 0;
      faqItems.forEach((item) => {
        const categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
        const textMatch = !query || item.dataset.search.includes(query);
        const visible = categoryMatch && textMatch;
        item.hidden = !visible;
        if (!visible) setFaqExpanded(item.querySelector('.faq-question'), false);
        if (visible) visibleCount += 1;
      });
      resultsCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'answer' : 'answers'} available`;
      noResults.hidden = visibleCount !== 0;
    }

    function setActiveCategory(category) {
      activeCategory = category;
      filterChips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.filter === category)));
      applyFilters();
    }

    filterChips.forEach((chip) => chip.addEventListener('click', () => setActiveCategory(chip.dataset.filter)));
    searchInput.addEventListener('input', applyFilters);
    clearFilters.addEventListener('click', () => {
      searchInput.value = '';
      setActiveCategory('all');
      searchInput.focus();
    });

    document.addEventListener('keydown', (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        searchInput.focus();
      }
    });

    function activateProductTab(tab, moveFocus = true) {
      productTabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        document.getElementById(item.getAttribute('aria-controls')).hidden = !selected;
      });
      if (moveFocus) tab.focus();
    }

    productTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateProductTab(tab, false));
      tab.addEventListener('keydown', (event) => {
        let targetIndex = index;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % productTabs.length;
        else if (event.key === 'ArrowLeft') targetIndex = (index - 1 + productTabs.length) % productTabs.length;
        else if (event.key === 'Home') targetIndex = 0;
        else if (event.key === 'End') targetIndex = productTabs.length - 1;
        else return;
        event.preventDefault();
        activateProductTab(productTabs[targetIndex]);
      });
    });

    applyFilters();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-dark"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.footer-dark-section');
    if (!sections.length) return;

    const desktopQuery = window.matchMedia('(min-width: 750px)');

    const syncColumns = () => {
      sections.forEach((section) => {
        section.querySelectorAll('.ft-col').forEach((column) => {
          column.open = desktopQuery.matches;
        });
      });
    };

    syncColumns();

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', syncColumns);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(syncColumns);
    }

    sections.forEach((section) => {
      const region = section.querySelector('[data-region]');
      if (!region) return;

      const list = region.querySelector('.region-list');
      const current = region.querySelector('.region-option.is-selected');

      region.addEventListener('toggle', () => {
        if (!region.open || !list || !current) return;

        list.scrollTop =
          current.offsetTop - list.offsetTop - list.clientHeight / 2 + current.offsetHeight / 2;
      });

      document.addEventListener('click', (event) => {
        if (!region.open) return;
        if (region.contains(event.target)) return;
        region.open = false;
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !region.open) return;

        region.open = false;
        const trigger = region.querySelector('summary');
        if (trigger) trigger.focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["group-navigation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // 获取所有导航项和目标元素
    const allNavItems = document.querySelectorAll('.nav-item');
    const navItems = Array.from(allNavItems).filter(item => {
      return window.getComputedStyle(item).display !== 'none';
    });

    const targetElements = new Map();
    
    // 创建目标元素映射
    navItems.forEach(item => {
      const targetId = item.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElements.set(targetId, targetElement);
      }
    });

    // 点击导航项事件
    navItems.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        
        // 移除所有激活状态
        navItems.forEach(nav => nav.classList.remove('active'));
        
        // 添加当前激活状态
        this.classList.add('active');
        
        // 获取目标ID并滚动到对应元素
        const targetId = this.getAttribute('data-target');
        const targetElement = targetElements.get(targetId);
        
        if (targetElement) {
          // 计算滚动位置（考虑固定导航栏高度）
          const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const navHeight = document.querySelector('.group-navigation').offsetHeight;
          
          // 平滑滚动到目标位置
          window.scrollTo({
            top: offsetTop - navHeight,
            behavior: 'smooth'
          });
        }
      });
    });

    // 监听滚动事件，根据滚动位置更新激活的导航项
    let ticking = false;

    function getOffsetTop(element) {
      let offsetTop = 0;
      let el = element;
      while (el) {
        offsetTop += el.offsetTop;
        el = el.offsetParent;
      }
      return offsetTop;
    }

    function updateActiveNav() {
      const navHeight = document.querySelector('.group-navigation').offsetHeight;
      const scrollPosition = window.scrollY + navHeight + 32;
      let activeTarget = null;
      let lastValidTarget = null;

      for (let [targetId, element] of targetElements) {
        const offsetTop = getOffsetTop(element);
        const offsetBottom = offsetTop + element.offsetHeight;

        if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
          activeTarget = targetId;
          break;
        }
        if (offsetTop < scrollPosition) {
          lastValidTarget = targetId;
        }
      }

      if (!activeTarget) {
        activeTarget = lastValidTarget;
      }
      if (!activeTarget && navItems.length > 0) {
        activeTarget = navItems[0].getAttribute('data-target');
      }

      navItems.forEach(item => {
        const targetId = item.getAttribute('data-target');
        item.classList.toggle('active', targetId === activeTarget);
      });

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateActiveNav);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });

    updateActiveNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center-app-detail"] && !Shopify.designMode) return;
  try {
    
window.HELP_CENTER_DATA = {  appGuideMeta: {
  "eyebrow": "AI DVR Link tutorials",
  "title": "UMEVO App Guide",
  "lead": "A practical, visual guide to connecting your recorder, transcribing conversations, using AI tools, and managing everything inside AI DVR Link.",
  "statNumber": "15",
  "statLabel": "step-by-step tutorials",
  "introTitle": "Start with the app, then follow the task you need.",
  "introText": "Every tutorial below uses the interface and screenshots supplied for AI DVR Link. Button names are shown exactly where they matter.",
  "ctaTitle": "Need help with a step?",
  "ctaText": "Send support your device model, SN, app version, and a screenshot of the issue."
},
  appGuideArticles: [
  {
    "id": "APP-01",
    "n": "01",
    "cat": "Setup & Connection",
    "title": "The AI DVR Link App",
    "lead": "UMEVO Note Plus works with the <strong>AI DVR Link</strong> mobile app for device connection, file synchronization, transcription, summaries, translation, and AI tools.",
    "blocks": [
      [
        "callout",
        "App name",
        "AI DVR Link"
      ]
    ]
  },
  {
    "id": "APP-02",
    "n": "02",
    "cat": "Setup & Connection",
    "title": "How to Bind Your Device",
    "lead": "Create an AI DVR Link account, sign in, and then complete these three steps.",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Power on Note Plus",
            "body": "Press and hold the power button in the upper-right corner for 3 seconds.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Device_power_on_480x480.png?v=1761638772",
              "Power button used to turn on UMEVO Note Plus",
              "Press and hold for 3 seconds."
            ]
          },
          {
            "title": "Open the connection screen",
            "body": "Open AI DVR Link, go to the file page, and tap the connection icon.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Connection_icon_8795f536-e965-4d33-9835-0327f30b5dce_480x480.png?v=1761638899",
              "Connection icon on the AI DVR Link file page",
              "Connection icon in AI DVR Link."
            ]
          },
          {
            "title": "Connect over Bluetooth",
            "body": "On the Bluetooth connection screen, select your recorder model and tap <strong>Connect Device</strong>.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Bluetooth_connect_480x480.png?v=1761638939",
              "Bluetooth device selection and connect button",
              "Select the correct model before connecting."
            ]
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-03",
    "n": "03",
    "cat": "Recording",
    "title": "How to Record and Switch Recording Modes",
    "lead": "Use a short press to start or stop recording, and set the side switch for the recording situation.",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Start recording",
            "body": "In either recording mode, press the power button for 1 second. The recorder vibrates once and the display shows the recording status.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Start_recording_fefb796b-3d65-414b-ba8d-02337f7eb3ab_480x480.png?v=1761639325",
              "UMEVO Note Plus showing recording in progress",
              "One vibration confirms recording has started."
            ]
          },
          {
            "title": "End and save the recording",
            "body": "Press the power button for 1 second again. The recorder vibrates twice and shows <strong>Save!</strong>.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/End_recording_a1802f70-9f88-4145-923c-9ffd0cbb924f_480x480.png?v=1761639365",
              "UMEVO Note Plus Save confirmation after recording",
              "Two vibrations confirm the recording has ended."
            ]
          },
          {
            "title": "Choose Normal Mode",
            "body": "Move the switch to the right for meetings, interviews, voice notes, and other room recordings. Hold the device or place it on a table.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Normal_mode_480x480.png?v=1761639494",
              "UMEVO Note Plus switch set to Normal Mode",
              "Normal Mode uses the recorder microphones."
            ]
          },
          {
            "title": "Choose Phone Mode",
            "body": "Move the switch to the left for phone calls. In this mode, the recorder captures vibration from the phone to record the conversation.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Phone_mode_480x480.png?v=1761639523",
              "UMEVO Note Plus switch set to Phone Mode",
              "Phone Mode is designed for vibration-based call recording."
            ],
            "note": "<strong>Tip:</strong> Attach Note Plus securely to the back of the phone before starting the call recording."
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-04",
    "n": "04",
    "cat": "Transcription & AI",
    "title": "How to Transcribe Selected Audio Segments",
    "lead": "Create a trimmed copy of the recording, then transcribe only that new file.",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Open the audio editor",
            "body": "Select the recording, enter the transcription interface, and tap the editing icon indicated in the interface.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Transcription_function_operation_interface_480x480.jpg?v=1761639788",
              "Audio editing icon in the transcription interface",
              "Open editing before starting transcription."
            ]
          },
          {
            "title": "Trim the audio",
            "body": "Remove unwanted parts or keep only the segment you need, then tap <strong>Save As</strong>.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Editing_function_operation_interface_480x480.png?v=1761639810",
              "Audio segment editing controls in AI DVR Link",
              "Select the portion you want to keep."
            ]
          },
          {
            "title": "Save and transcribe the new file",
            "body": "Name the edited segment and tap <strong>Save</strong>. Open the new recording and begin transcription.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Save_function_operation_interface_480x480.png?v=1761639829",
              "Save edited audio as a new recording",
              "The original recording remains available."
            ]
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-05",
    "n": "05",
    "cat": "Transcription & AI",
    "title": "How to Transcribe in the Original Language",
    "lead": "",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Open Transcription",
            "body": "Select the recording, open the <strong>Transcription</strong> page, and tap <strong>Transcribe</strong>.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Transcription_function_interface_480x480.jpg?v=1761640086",
              "Transcribe button in AI DVR Link",
              "Start from the selected recording."
            ]
          },
          {
            "title": "Select the recording language",
            "body": "Find <strong>Recording Language</strong> and choose the language spoken in the audio before generating the transcript.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Recording_language_selection_interface_480x480.jpg?v=1761640104",
              "Recording Language selector in AI DVR Link",
              "Match the setting to the source audio."
            ]
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-06",
    "n": "06",
    "cat": "Transcription & AI",
    "title": "How Speaker Identification Works",
    "lead": "AI DVR Link supports Speaker Diarization, which detects multiple speakers and adds speaker labels during transcription. You can assign names, and changes sync to the transcript.",
    "blocks": [
      [
        "figure",
        "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/speaker_id_480x480.png?v=1761640341",
        "Speaker diarization labels in an AI DVR Link transcript",
        "Enable speaker distinction when configuring transcription."
      ]
    ]
  },
  {
    "id": "APP-07",
    "n": "07",
    "cat": "Transcription & AI",
    "title": "How to Transcribe a Recording",
    "lead": "",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Sync and download the recording",
            "body": "Connect the recorder to AI DVR Link. Select the audio from the pending-download list, download it, and open it from the downloaded list.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Audio_file_interface_480x480.jpg?v=1761640767",
              "Pending and downloaded audio files in AI DVR Link",
              "Download the device file before transcription."
            ]
          },
          {
            "title": "Open transcription settings",
            "body": "Tap <strong>Transcription</strong> in the bottom toolbar to open the configuration panel.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Audio_transcription_function_operation_interface_480x480.jpg?v=1761640839",
              "Transcription button in the audio toolbar",
              "Use the bottom toolbar on the audio page."
            ]
          },
          {
            "title": "Configure and generate",
            "body": "Choose a summary template, enable <strong>Distinguish Speakers</strong> when needed, select the source language, and tap <strong>Generate Now</strong>.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Transcription_parameter_configuration_interface_480x480.jpg?v=1761640880",
              "Transcription language, template, and speaker settings",
              "Review the language and speaker options before generating."
            ]
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-08",
    "n": "08",
    "cat": "Transcription & AI",
    "title": "How to Generate Summaries and Mind Maps",
    "lead": "After transcription finishes, AI DVR Link automatically generates a structured summary and a visual mind map. To generate them again, open <strong>More</strong> in the upper-right corner and choose <strong>Re-summarize</strong>.",
    "blocks": [
      [
        "figure",
        "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Smart_summary_feature_interface_demonstration_480x480.png?v=1761641154",
        "Smart Summary and mind map interface in AI DVR Link",
        "The mind map is generated from the summary content."
      ]
    ]
  },
  {
    "id": "APP-09",
    "n": "09",
    "cat": "File Management & Sharing",
    "title": "How to Merge Audio Files",
    "lead": "",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Open file actions",
            "body": "Swipe left on a file in the audio list to display the available actions.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Audio_file_list_interface_480x480.jpg?v=1761641333",
              "Swipe-left file actions in the audio list",
              "Swipe left on any file to begin."
            ]
          },
          {
            "title": "Select and merge",
            "body": "Select multiple audio files, then tap <strong>Merge</strong> at the bottom. AI DVR Link creates a new merged audio file."
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-10",
    "n": "10",
    "cat": "File Management & Sharing",
    "title": "How to Delete Audio Files",
    "lead": "",
    "blocks": [
      [
        "note",
        "<strong>Important:</strong> Deleted files first move to the Recycle Bin. Delete them again inside the Recycle Bin only when you want permanent removal."
      ],
      [
        "steps",
        [
          {
            "title": "Open the selection interface",
            "body": "Swipe left on a file in the audio list to display the operation interface.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Audio_file_list_interface_480x480.jpg?v=1761641333",
              "Swipe-left file actions for deleting audio",
              "Open file actions from the audio list."
            ]
          },
          {
            "title": "Delete selected files",
            "body": "Select the audio files and tap <strong>Delete</strong> in the bottom toolbar.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Audio_file_operation_interface_480x480.png?v=1761641692",
              "Delete button for selected audio files",
              "The files move to the Recycle Bin."
            ]
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-11",
    "n": "11",
    "cat": "File Management & Sharing",
    "title": "How to Restore Files from the Recycle Bin",
    "lead": "",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Open the sidebar",
            "body": "On the audio list page, tap the indicated menu button to expand the sidebar.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Device_Power_On_2_480x480.jpg?v=1761641900",
              "Sidebar menu button on the AI DVR Link audio page",
              "Open the navigation sidebar."
            ]
          },
          {
            "title": "Enter the Recycle Bin",
            "body": "Tap <strong>Recycle Bin</strong> in the sidebar to view deleted audio files.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Enter_the_Recycle_Bin_480x480.jpg?v=1761641973",
              "Recycle Bin item in the AI DVR Link sidebar",
              "Deleted files remain here until permanently removed."
            ]
          },
          {
            "title": "Show file actions",
            "body": "Swipe left on an audio file in the Recycle Bin.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Show_Operation_Options_480x480.jpg?v=1761642105",
              "Restore options revealed by swiping left in the Recycle Bin",
              "Select the files you want to recover."
            ]
          },
          {
            "title": "Restore the files",
            "body": "Select the audio files and tap <strong>Restore</strong> in the bottom toolbar.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Restore_Audio_Files_480x480.png?v=1761642137",
              "Restore button for selected audio files",
              "The selected files return to the audio list."
            ]
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-12",
    "n": "12",
    "cat": "Transcription & AI",
    "title": "How to Name Speakers",
    "lead": "",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Open Edit Speaker",
            "body": "Open a transcribed audio file and tap <strong>Edit Speaker</strong> on the Transcription page.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Transcription_operation_interface_480x480.jpg?v=1761642347",
              "Edit Speaker button on the Transcription page",
              "Select the transcript that needs speaker names."
            ]
          },
          {
            "title": "Name and confirm",
            "body": "Enter a name for each speaker and tap <strong>Confirm</strong>. The names update automatically throughout the transcript.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Speaker_naming_operation_interface_480x480.png?v=1761642495",
              "Speaker naming interface with Confirm button",
              "Confirmed names replace generic speaker labels."
            ]
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-13",
    "n": "13",
    "cat": "File Management & Sharing",
    "title": "How to Share and Export Files",
    "lead": "Share a link to recorded audio, transcripts, summaries, or mind maps. The shared link expires after <strong>7 days</strong>.",
    "blocks": [
      [
        "figure",
        "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/share_files_480x480.png?v=1765163933",
        "Share options for an AI DVR Link recording",
        "Use the share menu on the content page."
      ],
      [
        "options",
        [
          [
            "Copy Transcription",
            "Copy transcript text to the clipboard."
          ],
          [
            "Copy Summary",
            "Copy summary text to the clipboard."
          ],
          [
            "Export Audio",
            "Export the audio file."
          ],
          [
            "Export Transcription",
            "Export the complete transcript."
          ],
          [
            "Export Summary",
            "Export the generated key points."
          ],
          [
            "Export Mind Map",
            "Export the visual mind map."
          ],
          [
            "Export Translated Transcription",
            "Export translated transcript text."
          ],
          [
            "Export Translated Summary",
            "Export translated summary text."
          ]
        ]
      ],
      [
        "figure",
        "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/export_format.jpg?v=1765163939",
        "Supported export format reference in AI DVR Link",
        "Choose a format appropriate for the content being exported."
      ]
    ]
  },
  {
    "id": "APP-14",
    "n": "14",
    "cat": "Translation",
    "title": "How to Translate Transcripts and Summaries",
    "lead": "",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Choose Translate",
            "body": "On a transcript or summary page, tap <strong>Translate</strong>.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Translation_function_interface_480x480.jpg?v=1765164517",
              "Translate button and language selector in AI DVR Link",
              "Translation is available from transcript and summary pages."
            ]
          },
          {
            "title": "Select the target language",
            "body": "Choose the target language, then tap <strong>Transcription Translation</strong> or <strong>Summary Translation</strong>. The translated result appears when processing is complete."
          }
        ]
      ]
    ]
  },
  {
    "id": "APP-15",
    "n": "15",
    "cat": "Transcription & AI",
    "title": "How to Use Ask AI",
    "lead": "Ask AI works with a completed transcript to answer questions, extract information, and help draft reports, documents, or emails.",
    "blocks": [
      [
        "steps",
        [
          {
            "title": "Open Ask AI",
            "body": "Select a transcribed audio file, open the transcription page, and tap <strong>Ask AI</strong> at the bottom.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Transcription_function_operation_interface_c3c9206e-50ad-4bbd-bb41-c7582ea4acb0_480x480.jpg?v=1765165000",
              "Ask AI button on a completed transcript",
              "Ask AI becomes useful after transcription is available."
            ]
          },
          {
            "title": "Enter your question",
            "body": "Type the question or information you need, then tap send to receive an answer based on the transcript.",
            "figure": [
              "https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Ask_AI_Q_amp_A_interface_480x480.png?v=1765165039",
              "Ask AI question and answer interface",
              "Use focused questions for more useful results."
            ]
          }
        ]
      ]
    ]
  }
],};

window.HELP_CENTER_DATA.appGuideArticles.push(
  {
    id: "note-one-app-connect", product: "note-one", n: "01", cat: "Setup & Connection",
    title: "Connect Note One to the UMEVO App",
    lead: "Use the UMEVO App for Note One. First-time account binding and activation require an internet connection.",
    blocks: [
      ["steps", [
        { title: "Install UMEVO and sign in", body: "Search for UMEVO in the App Store or Google Play. Install the app and create an account or sign in. Turn on Note One by holding its main button for three seconds. If it is already on with a dark screen, briefly press the button to wake the screen." },
        { title: "Choose your recorder", body: "Open the device connection screen in the app and select UMEVO Note One. Enable Bluetooth and follow the app and phone permission prompts to connect and bind the device.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/APP-Select_Decice.png?v=1791959469", "Choose UMEVO Note One rather than Note Plus.", "Choose your product in the UMEVO App."] },
        { title: "Check the connected device", body: "Open the connected device's information to check the model, battery level, recording mode, and serial number. One device can connect to one phone at a time.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/APP-device-connected.png?v=1791959612", "The connected Note One device information screen.", "Check the model, battery, recording mode, and SN."] }
      ]],
      ["note", "If Note One is already bound to another account, it must be unbound from that account before it can be bound to yours. Contact support@umevo.ai if you cannot access the original account."]
    ]
  },
  {
    id: "note-one-app-record", product: "note-one", n: "02", cat: "Recording",
    title: "Control Recording, Pause, and Mark Important Moments",
    lead: "Start Recording in the app controls your connected Note One. It does not record through your phone's microphone.",
    blocks: [
      ["steps", [
        { title: "Connect Note One and start recording", body: "Connect the recorder, then use Start Recording in the app. Set NOTE Mode for in-person audio or CALL Mode for phone calls using the recorder's physical switch." },
        { title: "Pause or add a mark", body: "Use Pause to pause a recording. Use Input, Take Photo, or Mark to add context and highlight important moments while recording.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Start_Recording_c047901b-39ce-4cf9-be60-9633ec57a1df.png?v=1791959994", "Recording controls and the Input, Take Photo, and Mark tools.", "Control recording on the connected Note One."] },
        { title: "End and save", body: "Tap End. In the End recording confirmation, tap End and save, or Continue recording if you are not finished. Wait for the recording to save before transferring it.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/End-recording.png?v=1791960119", "Confirm End and save to finish the recording.", "Wait for the file to save before transfer."] }
      ]],
      ["note", "Note One can also record independently without a phone connection. Recordings made while disconnected may need to be added from From Device before they appear in your main list."]
    ]
  },
  {
    id: "note-one-app-offline-recordings", product: "note-one", n: "03", cat: "Files & Sharing",
    title: "Find Offline Recordings and Add Them to Your List",
    lead: "After Note One records independently and reconnects to the app, those recordings do not appear in the main All Files list by default. Add the recording to your list before generating a transcript and summary.",
    blocks: [
      ["steps", [
        { title: "Reconnect Note One", body: "Stop and save the recording on Note One, then reconnect the recorder to the UMEVO App. Keep it connected while accessing its recordings." },
        { title: "Open All Files and find From Device", body: "On the recording list page, tap All Files. In the menu, find the From Device section. Choose Meeting Mode or Call Mode according to how you recorded the audio.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/From_device.png?v=1792035065", "From Device appears below Folders in the All Files menu. Select Meeting Mode or Call Mode.", "Open All Files → From Device → Meeting Mode or Call Mode."] },
        { title: "Select the recording and tap Add to List", body: "Find the recording by its date and time, then tap it. In the panel that opens, tap Add to List. Use Add to List, not Confirm Delete, to keep the recording and add it to your main list.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/From_device-add_to_list.png?v=1792035891", "Tap the green Add to List button. An Added label identifies recordings already added.", "Add to List keeps the recording; Confirm Delete is a different action."] },
        { title: "Open the recording from your list", body: "Return to All Files and open the added recording. Once its audio is available in the app, tap Generate to create its transcript, summary, and mind map. AI processing requires internet access." }
      ]],
      ["note", "Automatic audio transfer and adding a recording to your list are different steps. If a recording made offline is missing from the main list, check From Device before assuming it has been lost."]
    ]
  },
  {
    id: "note-one-app-transfer", product: "note-one", n: "04", cat: "Setup & Connection",
    title: "Understand Bluetooth and Fast Transfer",
    lead: "Bluetooth is the default transfer method. Note One also supports faster transfer using the device's own hotspot, without a router or internet connection for the local audio transfer.",
    blocks: [
      ["steps", [
        { title: "Open the device's transfer information", body: "Connect Note One and open its device information. Find Transfer to UMEVO and tap Transfer to UMEVO App to view the transfer explanation.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/transfer_to_umevo_app_1.png?v=1792035066", "Transfer to UMEVO App is located in the device information screen.", "Open Transfer to UMEVO App."] },
        { title: "Understand the two transfer methods", body: "Bluetooth transfer starts automatically when the device connects to the app. Fast Transfer uses a hotspot created by Note One to transfer recordings more quickly to the app. Follow the connection guidance shown by your current app version if you use this method.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/transfer_to_umevo_app_2.png?v=1792035066", "The app explains Bluetooth transfer and hotspot-based Fast Transfer on this page.", "Local transfer does not require a router or internet access."] },
        { title: "Check the right recording list", body: "Audio transfer does not mean every device recording appears in All Files automatically. For recordings made offline, open All Files, find From Device, choose Meeting Mode or Call Mode, and add the recording using Add to List." }
      ]],
      ["note", "Stop recording before transferring audio. Internet access is needed later for AI processing, not for the local device-to-phone transfer."]
    ]
  },
  {
    id: "note-one-app-import-audio", product: "note-one", n: "05", cat: "Files & Sharing",
    title: "Import Audio into the UMEVO App", lead: "You can process existing audio as well as recordings captured by Note One.",
    blocks: [
      ["steps", [
        { title: "Open Import Audio", body: "Open the recording controls from the app's file list and tap Import Audio. Use the file selection flow on your phone to choose the audio you want to import.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/cf014ed5835bf7df70fc8b3cc33f83b1.png?v=1792035980", "Tap Import Audio to begin. This guide shows the import entry point.", "Import existing audio from your phone."] },
        { title: "Choose supported audio", body: "Supported import formats are MP3, WAV, and M4A. Multiple files can be imported. Once an imported file is available in your list, open it and use Generate." },
        { title: "Generate your notes online", body: "Use Auto Generate for the default workflow, or Custom Generate to choose a template, speaker labeling, and audio language. Your Note One promotional minutes can also be used for imported audio." }
      ]],
      ["note", "There is no hard duration or file-size limit for processing one audio file. To keep processing time manageable, we recommend files of 180 minutes or less."]
    ]
  },
  {
    id: "note-one-app-generate", product: "note-one", n: "06", cat: "Transcription & AI",
    title: "Generate a Transcript, Summary, and Mind Map",
    lead: "Transcription, summarization, and the mind map are generated together after recording. There is no separate transcription-only button in this workflow.",
    blocks: [
      ["steps", [
        { title: "Open the recording and choose Generate", body: "Open a recording in your app list and tap Generate. If it was recorded offline and is missing from the list, add it through From Device first." },
        { title: "Choose Auto Generate", body: "Select Auto Generate for the automatic workflow, then tap Generate Now. Choose Custom Generate instead if you want to set a template, speaker labeling, or the audio language before processing.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Auto-Generate.png?v=1791960234", "Choose Auto Generate or Custom Generate before starting the AI task.", "Choose a generation workflow, then tap Generate Now."] },
        { title: "Wait for processing", body: "Keep an internet connection while the app processes the audio. The progress view shows the current stage and percentage.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Auto_Generate-_-40.png?v=1791960325", "The app displays AI processing progress.", "Follow the processing stage and percentage."] },
        { title: "Review the results", body: "Open Source to read the transcript, and Note to read the summary. View the generated mind map from the recording's results. Generating the mind map with the transcript and summary does not deduct additional minutes." }
      ]],
      ["note", "A complete AI task uses minutes based on the audio duration. Failed tasks do not deduct minutes. Changing the template to regenerate only the summary is a separate, free operation."]
    ]
  },
  {
    id: "note-one-app-custom-generate", product: "note-one", n: "07", cat: "Transcription & AI",
    title: "Choose a Template, Speakers, and Audio Language",
    lead: "Custom Generate lets you review the available generation settings before creating your transcript and summary.",
    blocks: [
      ["steps", [
        { title: "Select Custom Generate", body: "Open the recording, tap Generate, then select Custom Generate to reveal its settings.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Custom_Generate.png?v=1792035066", "Custom Generate shows Template, Auto-label speakers, Audio Language, and the available AI Model setting.", "Review the available generation settings."] },
        { title: "Choose a template and speaker labels", body: "Tap Template to choose the summary format you want. Enable Auto-label speakers if you want the transcript to distinguish speakers. After generation, you can replace speaker labels with names." },
        { title: "Set the audio language and generate", body: "Use Audio Language to review or choose the language spoken in the recording. UMEVO supports 114 transcription languages. Review your settings, then tap Generate Now." }
      ]],
      ["note", "Mixed languages within a single recording are not currently supported. Choose the language of the recording rather than treating the language setting as a translation tool."]
    ]
  },
  {
    id: "note-one-app-name-speakers", product: "note-one", n: "08", cat: "Transcription & AI",
    title: "Replace Speaker Labels with Names",
    lead: "Speaker labels make a conversation easier to follow. You can rename the labels after the transcript has been generated.",
    blocks: [
      ["steps", [
        { title: "Open a transcript with speaker labels", body: "Open the recording's Source view and find the speaker label you want to change. For future recordings, enable Auto-label speakers in Custom Generate before generation." },
        { title: "Edit the speaker name", body: "Select the speaker label to open Name speaker. Replace a label such as Speaker 1 with the person's name, then tap Save. Repeat for other speakers as needed.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/name_speaker.png?v=1792035065", "Enter a name in the Name speaker panel, then save the change.", "Replace the speaker label, then tap Save."] }
      ]],
      ["note", "Check who is speaking before assigning a name. Speaker labels are generated by AI and may need your review."]
    ]
  },
  {
    id: "note-one-app-review-results", product: "note-one", n: "09", cat: "Transcription & AI",
    title: "Read Transcripts, Summaries, and Mind Maps",
    lead: "Review generated content against the original audio before sharing or using it for important decisions.",
    blocks: [
      ["steps", [
        { title: "Read the transcript in Source", body: "Open Source to view the transcript. Use playback and timestamps to return to the relevant part of the audio, and review the speaker labels.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Tab1-1.png?v=1791960581", "Example transcript with timestamps and speaker labels.", "Example content: Source transcript view."] },
        { title: "Read the summary in Note", body: "Open Note to read the generated summary. The selected template determines how the summary is organized. Transcripts and summaries can be edited.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Tab2-1.png?v=1791960619", "Example summary showing key points, decisions, and next steps.", "Example content: Note summary view."] },
        { title: "View the mind map", body: "Open the generated mind map to review the structure visually. The mind map is generated with the transcript and summary. Mind map editing and separate mind map regeneration are not currently supported.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Tab2-2.png?v=1791960647", "Example mind map generated from the recording.", "Example content: generated mind map."] }
      ]],
      ["note", "The screenshots show example recording content. AI-generated results can contain errors; verify details against the audio."]
    ]
  },
  {
    id: "note-one-app-change-template", product: "note-one", n: "10", cat: "Transcription & AI",
    title: "Regenerate Only the Summary Without Using Minutes",
    lead: "Changing the summary template regenerates only the summary. It does not rerun transcription and does not deduct minutes.",
    blocks: [
      ["steps", [
        { title: "Open the existing summary", body: "Open a recording that already has a generated summary, then select Note." },
        { title: "Tap + beside Summary", body: "At the top of the summary view, tap the + button next to Summary. Choose Change template from the menu.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/change_template.png?v=1792035066", "Tap + beside Summary, then choose Change template.", "Change the summary template without transcribing again."] },
        { title: "Choose a template and regenerate the summary", body: "Select the summary template you want and follow the app's prompts to generate the new summary. The transcript does not need to be generated again, and this summary-only template change does not use minutes." }
      ]],
      ["note", "This is different from rerunning the complete AI task. Rerunning the complete task deducts minutes again based on the full duration of the original audio."]
    ]
  },
  {
    id: "note-one-app-export", product: "note-one", n: "11", cat: "Files & Sharing",
    title: "Share and Export Your Recording and AI Notes",
    lead: "Use the share icon on a recording's detail page to choose how to share or export its content.",
    blocks: [
      ["steps", [
        { title: "Open Share", body: "Open the recording and tap the share icon at the top. In Share, choose Share link to share access, Copy to clipboard to copy supported text, or a content type under Export file.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Sahre.png?v=1791960711", "The Share panel contains link sharing, clipboard options, and file exports.", "Choose link sharing, clipboard, or file export."] },
        { title: "Export a transcript", body: "Choose Transcript under Export file. Select the export format, choose whether to include timestamps, then tap Export.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/Sahre_-_Transcript.png?v=1791960782", "Choose transcript export settings and tap Export.", "Choose a format and whether to include timestamps."] },
        { title: "Choose the right format", body: "Audio exports as MP3. Transcripts and summaries support TXT, SRT, DOCX, and PDF. Mind maps support JPEG and Markdown. Choose the corresponding content type from the export menu." }
      ]],
      ["note", "You can continue exporting content that has already been generated even when your AI minutes have run out. Shared links can be opened without signing in and can be revoked."]
    ]
  },
  {
    id: "note-one-app-cloud-sync", product: "note-one", n: "12", cat: "Cloud & Web",
    title: "Manage Private Cloud Sync",
    lead: "Private Cloud Sync is enabled by default. It can sync original audio, transcripts, summaries, and mind maps between the app and UMEVO Web.",
    blocks: [
      ["steps", [
        { title: "Open Private Cloud Sync", body: "Open the app's More area and select Private Cloud Sync. Use Enable Private Cloud Sync to control syncing. If you want automatic cloud syncing only over Wi-Fi, use Sync only on Wi-Fi.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/APP-_-_Private_Cloud_Sync.png?v=1791960836", "Private Cloud Sync settings, including the sync switch and Delete Cloud Recordings.", "Review sync settings and cloud storage before cleanup."] },
        { title: "Understand what turning sync off does", body: "Turning sync off stops future syncing but keeps content already stored in the cloud. You can still upload audio for AI processing. With sync off, temporary data uploaded for AI processing is retained for three days; this does not apply to previously synced content." },
        { title: "Use cloud cleanup carefully", body: "Delete Cloud Recordings removes cloud copies without deleting content on your phone. This is different from deleting an individual recording in the app, which affects its cloud copy and the original device recording." }
      ]],
      ["note", "Keep a separate backup of important recordings before deleting content. Turning off cloud sync is not the same as deleting existing cloud recordings."]
    ]
  },
  {
    id: "note-one-app-web", product: "note-one", n: "13", cat: "Cloud & Web",
    title: "Continue on Your Computer with UMEVO Web",
    lead: "UMEVO Web is the browser version of UMEVO. There is currently no installable UMEVO Desktop app.",
    blocks: [
      ["steps", [
        { title: "Sign in to UMEVO Web", body: "Open UMEVO Web in your computer's browser and sign in to your UMEVO account. To view content from the app, keep Private Cloud Sync enabled for the content you want to sync.", figure: ["https://cdn.shopify.com/s/files/1/0922/8776/2505/files/umevo_web.png?v=1791960877", "UMEVO Web in a computer browser.", "Access synced content or import audio in your browser."] },
        { title: "Work with your audio and notes", body: "Access synced recordings, transcripts, summaries, and mind maps. UMEVO Web also supports directly importing audio and generating transcripts and summaries." },
        { title: "Use the same minute balance", body: "The app and UMEVO Web share one minute balance. Using the browser does not create a second allowance." }
      ]],
      ["note", "If a recording is missing from Web, check that it has been added to the app list and that Private Cloud Sync is enabled. A recording still listed only under From Device is not the same as an item already available in your app library."]
    ]
  }
);

  (function () {
    "use strict";

    function init() {
      var DATA = HELP_CENTER_DATA;
      if (!DATA || !DATA.appGuideArticles) return;

      var params = new URLSearchParams(window.location.search);
      var requested = params.get("id") || window.location.hash.slice(1);
      var match = DATA.appGuideArticles.find(function (item) { return item.id === requested; });
      var product = match ? (match.product || "note-plus") : (params.get("product") === "note-one" ? "note-one" : "note-plus");
      var articles = DATA.appGuideArticles.filter(function (item) { return (item.product || "note-plus") === product; });
      var meta = DATA.appGuideMeta;
      var index = Math.max(0, articles.findIndex(function (item) { return item.id === requested; }));
      var article = articles[index];
      var previous = articles[index - 1];
      var next = articles[index + 1];
      var sidebar = document.querySelector(".help-center-app-guide-detail .side-nav");
      if (sidebar) {
        sidebar.innerHTML = '<strong>All ' + (product === "note-one" ? "Note One" : "Note Plus") + ' tutorials</strong>' + articles.map(function (item) {
          return '<a data-guide-id="' + escapeAttr(item.id) + '" href="/pages/help-center-app-guide-detail?id=' + encodeURIComponent(item.id) + '"><span class="side-index">' + item.n + '</span>' + escapeAttr(item.title) + '</a>';
        }).join("");
      }
      setText(".js-guide-product", "Product: UMEVO " + (product === "note-one" ? "Note One" : "Note Plus"));
      setText(".js-guide-app", "App: " + (product === "note-one" ? "UMEVO App" : "AI DVR Link"));
      var back = document.querySelector('.help-center-app-guide-detail .breadcrumb a[href="/pages/help-center-app-guides"]');
      if (back) back.href += "?product=" + product;

    function escapeAttr(text) {
      return String(text).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    function guideFigure(src, alt, caption) {
      return '<figure class="guide-figure">' +
        '<img class="guide-img" src="' + src + '" alt="' + escapeAttr(alt) + '" loading="lazy" decoding="async">' +
        (caption ? '<figcaption>' + caption + '</figcaption>' : "") +
        "</figure>";
    }

    function stepBlock(steps) {
      return '<div class="step-list">' + steps.map(function (step, i) {
        var html = '<div class="step"><div class="step-number">' + (i + 1) + '</div><div class="step-body">';
        html += '<h3>' + step.title + "</h3>";
        if (step.body) html += "<p>" + step.body + "</p>";
        if (step.note) html += '<div class="notice">' + step.note + "</div>";
        if (step.figure) html += guideFigure(step.figure[0], step.figure[1], step.figure[2]);
        return html + "</div></div>";
      }).join("") + "</div>";
    }

    function renderBlocks(blocks) {
      return (blocks || []).map(function (block) {
        var kind = block[0], a = block[1], b = block[2], c = block[3];
        switch (kind) {
          case "p": return "<p>" + a + "</p>";
          case "h3": return '<h3 class="block-heading">' + a + "</h3>";
          case "note": return '<div class="notice">' + a + "</div>";
          case "callout": return '<div class="answer-callout"><strong>' + a + "</strong><span>" + b + "</span></div>";
          case "figure": return guideFigure(a, b, c);
          case "video": return '<div class="video-frame"><iframe src="' + a + '" title="' + escapeAttr(b) + '" loading="lazy" allowfullscreen></iframe></div>';
          case "steps": return stepBlock(a);
          case "olist": return '<ol class="plain-list">' + a.map(function (item) { return "<li>" + item + "</li>"; }).join("") + "</ol>";
          case "cards": return '<div class="content-cards">' + a.map(function (card) {
            return '<div class="info-card content-card"><span class="tag">' + card[0] + "</span><h3>" + card[1] + "</h3><p>" + card[2] + "</p></div>";
          }).join("") + "</div>";
          case "packlist": return '<ul class="pack-list">' + a.map(function (item, i) {
            return '<li><span class="pack-index">' + String(i + 1).padStart(2, "0") + "</span><span>" + item[0] + "</span>" +
              (item[1] ? '<span class="pack-note">' + item[1] + "</span>" : "") + "</li>";
          }).join("") + "</ul>";
          case "options": return '<div class="option-grid">' + a.map(function (option) {
            return '<div class="option"><strong>' + option[0] + "</strong><span>" + option[1] + "</span></div>";
          }).join("") + "</div>";
          case "stats": return '<div class="stat-strip">' + a.map(function (stat) {
            return '<div><span class="stat-number">' + stat[0] + '</span><span class="stat-caption">' + stat[1] + "</span></div>";
          }).join("") + "</div>";
          case "specs": return '<div class="comparison-scroll"><table class="comparison-table spec-table"><tbody>' +
            a.map(function (row) { return "<tr><td>" + row[0] + "</td><td>" + row[1] + "</td></tr>"; }).join("") + "</tbody></table></div>";
          case "formats": return '<div class="format-table">' + a.map(function (row) {
            return '<div class="format-row"><span class="format-type">' + row[0] + '</span><span class="format-tags">' +
              row[1].map(function (tag) { return '<span class="tag">' + tag + "</span>"; }).join("") + "</span></div>";
          }).join("") + "</div>";
          case "faq": return '<div class="faq-list">' + a.map(function (pair) {
            return '<div class="faq-item"><button class="faq-question" type="button" aria-expanded="false"><span class="faq-title">' + pair[0] + '</span><span class="plus" aria-hidden="true">+</span></button><div class="faq-answer"><div class="faq-answer-body"><p>' + pair[1] + "</p></div></div></div>";
          }).join("") + "</div>";
          case "twocol": return '<div class="content-cards two">' + a.map(function (col) {
            var html = '<div class="info-card content-card"><h3>' + col[0] + "</h3>";
            if (col[2]) html += guideFigure(col[2][0], col[2][1], "");
            if (col[3]) html += guideFigure(col[3][0], col[3][1], "");
            html += '<ul class="plain-list bullets">' + col[1].map(function (line) { return "<li>" + line + "</li>"; }).join("") + "</ul></div>";
            return html;
          }).join("") + "</div>";
          case "subcard": return '<div class="info-card sub-card"><h3>' + a + "</h3>" + renderBlocks(b) + "</div>";
          default: return "";
        }
      }).join("");
    }

    function setText(selector, text) {
      var el = document.querySelector(selector);
      if (el) el.textContent = text;
    }

    document.querySelector(".js-guide-title").textContent = article.title;
    setText(".js-guide-cat", article.cat);
    setText(".js-guide-heading", article.title);
    var leadEl = document.querySelector(".js-guide-lead");
    if (leadEl) leadEl.innerHTML = article.lead || "";
    setText(".js-guide-position", "Tutorial " + article.n + " of " + articles.length);
    setText(".js-guide-cta", meta.ctaText);

    var body = document.querySelector(".js-guide-body");
    if (body) body.innerHTML = renderBlocks(article.blocks);

    document.querySelectorAll(".side-nav a[data-guide-id]").forEach(function (link) {
      link.classList.toggle("active", link.dataset.guideId === article.id);
    });

    var prev = document.querySelector(".js-pager-prev");
    var nextLink = document.querySelector(".js-pager-next");
    if (previous) {
      prev.href = "/pages/help-center-app-guide-detail?id=" + previous.id;
      prev.querySelector(".js-pager-prev-title").textContent = previous.title;
    } else if (prev) {
      prev.style.display = "none";
    }
    if (next) {
      nextLink.href = "/pages/help-center-app-guide-detail?id=" + next.id;
      nextLink.querySelector(".js-pager-next-title").textContent = next.title;
    } else if (nextLink) {
      nextLink.style.display = "none";
    }

    document.title = article.title + " | UMEVO Help Center";
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center-faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    document.addEventListener('keydown', function (event) {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        var input = document.getElementById('siteSearch');
        if (input) input.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["note-one-page-3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.note-one-page-3-section');
    if (!root) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.flow-tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.flow-panel'));
    var recordPanel = root.querySelector('.panel-record');
    var modeSwitch = root.querySelector('.mode-switch');
    var rotationTimer = null;

    if (reduceMotion) {
      root.querySelectorAll('video').forEach(function (video) {
        video.removeAttribute('autoplay');
        video.pause();
      });
    }

    function syncToggle(btn) {
      var panel = btn.closest('.flow-panel');
      var video = panel ? panel.querySelector('video') : null;
      if (!video) return;
      var paused = video.paused;
      btn.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    root.querySelectorAll('.video-toggle').forEach(function (btn) {
      var panel = btn.closest('.flow-panel');
      var video = panel ? panel.querySelector('video') : null;
      if (!video) return;
      btn.addEventListener('click', function () {
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', function () {
        syncToggle(btn);
      });
      video.addEventListener('pause', function () {
        syncToggle(btn);
      });
      syncToggle(btn);
      if (video.readyState >= 2) {
        btn.classList.add('is-ready');
      } else {
        video.addEventListener(
          'loadeddata',
          function () {
            btn.classList.add('is-ready');
          },
          { once: true }
        );
      }
    });

    function setMode(call) {
      recordPanel.classList.toggle('is-call', call);
      modeSwitch.setAttribute('aria-checked', call ? 'true' : 'false');
      root.querySelectorAll('.record-set-note').forEach(function (el) {
        el.setAttribute('aria-hidden', call ? 'true' : 'false');
      });
      root.querySelectorAll('.record-set-call').forEach(function (el) {
        el.setAttribute('aria-hidden', call ? 'false' : 'true');
      });
    }

    function stopRotation() {
      if (rotationTimer) {
        clearInterval(rotationTimer);
        rotationTimer = null;
      }
    }

    function startRotation() {
      if (reduceMotion || rotationTimer) return;
      rotationTimer = setInterval(function () {
        setMode(!recordPanel.classList.contains('is-call'));
      }, 5000);
    }

    modeSwitch.addEventListener('click', function () {
      setMode(!recordPanel.classList.contains('is-call'));
      stopRotation();
      startRotation();
    });

    function activate(name) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-tab') === name;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-panel') === name;
        panel.classList.toggle('is-active', on);
        panel.toggleAttribute('hidden', !on);
        panel.querySelectorAll('video').forEach(function (video) {
          if (on) {
            if (!reduceMotion) video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      });
      if (name === 'record') {
        startRotation();
      } else {
        stopRotation();
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-tab'));
      });
    });
    activate(tabs[0].getAttribute('data-tab'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["note-one-page-4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.note-one-page-4-section');
    if (!root) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var card = root.querySelector('.out-card');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.out-nav-item'));
    var bodies = Array.prototype.slice.call(root.querySelectorAll('.out-body'));
    var medias = Array.prototype.slice.call(root.querySelectorAll('.out-media'));
    var timer = null;

    function restart() {
      if (reduceMotion) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        card.classList.toggle('is-flip');
      }, 5000);
    }

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      [bodies, medias].forEach(function (group) {
        group.forEach(function (el, i) {
          var on = i === index;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      });
      card.classList.remove('is-flip');
      restart();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(Number(tab.getAttribute('data-index')));
      });
    });

    root.querySelectorAll('.out-media img').forEach(function (img) {
      img.addEventListener('click', function () {
        card.classList.toggle('is-flip');
        restart();
      });
    });

    restart();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["note-one-page-model"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('note-one-page-model')) return;

    const MODEL_VIEWER_SOURCES = [
      {
        url: 'https://cdn.jsdelivr.net/npm/@google/model-viewer@4.0.0/dist/model-viewer.min.js',
        type: 'module',
      },
      {
        url: 'https://unpkg.com/@google/model-viewer@4.0.0/dist/model-viewer.min.js',
        type: 'module',
      },
      { url: 'https://cdn.shopify.com/shopifycloud/model-viewer/v1.0/model-viewer.js', type: '' },
    ];

    const INTRO_ORBIT = {
      start: '0deg 84deg auto',
      turn: '-30deg 84deg auto',
      end: '0deg 84deg auto',
    };
    const INTRO_ROTATION_DURATION = 1000;
    const INTRO_ROTATION_PAUSE = 500;

    let viewerLoader;

    function waitForViewer(timeout) {
      return new Promise((resolve) => {
        if (customElements.get('model-viewer')) {
          resolve(true);
          return;
        }

        let timer;
        const done = () => {
          window.clearTimeout(timer);
          resolve(Boolean(customElements.get('model-viewer')));
        };

        customElements.whenDefined('model-viewer').then(done);
        timer = window.setTimeout(done, timeout);
      });
    }

    const injectedSources = new Set();

    function injectViewerScript(url, type) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        if (type) script.type = type;
        script.src = url;
        script.crossOrigin = 'anonymous';
        script.dataset.noteOneModel = '';
        script.addEventListener('load', () => resolve(), { once: true });
        script.addEventListener(
          'error',
          () => {
            script.remove();
            injectedSources.delete(url);
            reject(new Error(`Unable to load ${url}`));
          },
          { once: true }
        );
        injectedSources.add(url);
        document.head.appendChild(script);
      });
    }

    async function loadModelViewer() {
      if (customElements.get('model-viewer')) return;
      if (viewerLoader) return viewerLoader;

      viewerLoader = (async () => {
        if (typeof window.Shopify?.loadFeatures === 'function') {
          try {
            window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.0' }]);
          } catch (error) {
            /* Fall back to the CDN sources below. */
          }
          if (await waitForViewer(4000)) return;
        }

        for (const source of MODEL_VIEWER_SOURCES) {
          if (injectedSources.has(source.url)) continue;

          try {
            await injectViewerScript(source.url, source.type);
          } catch (error) {
            continue;
          }
          if (await waitForViewer(8000)) return;
        }

        throw new Error('Unable to load the 3D viewer.');
      })().catch((error) => {
        viewerLoader = undefined;
        throw error;
      });

      return viewerLoader;
    }

    class NoteOnePageModel extends HTMLElement {
      connectedCallback() {
        this.viewer = this.querySelector('model-viewer');
        this.feedback = this.querySelector('[data-feedback]');
        this.status = this.querySelector('[data-status]');
        this.retryButton = this.querySelector('[data-retry]');
        this.stage = this.querySelector('.note-one-page-model__stage');
        this.colors = Array.from(this.querySelectorAll('.note-one-page-model__color'));
        if (!this.viewer || !this.feedback || !this.status || !this.retryButton) return;

        this.events = new AbortController();
        const { signal } = this.events;

        this.addEventListener(
          'click',
          (event) => {
            const color = event.target.closest?.('.note-one-page-model__color');
            if (!color) return;
            this.select(color);
            color.focus({ preventScroll: true });
          },
          { signal }
        );
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.retryButton.addEventListener('click', () => this.loadSelection(), { signal });
        this.setState('loading', '');

        if ('IntersectionObserver' in window) {
          this.loadObserver = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.loadObserver?.disconnect();
              this.loadSelection();
            },
            { rootMargin: '800px 0px' }
          );
          this.loadObserver.observe(this);

          const revealThresholds = Array.from({ length: 21 }, (_, index) => index / 20);
          this.revealObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[entries.length - 1];
              if (!entry) return;

              const height = entry.boundingClientRect.height || 1;
              const reachable = Math.min(1, (window.innerHeight || height) / height);
              this.isVisible = entry.intersectionRatio >= Math.min(0.5, reachable * 0.85);

              if (this.isVisible && this.pendingReveal) this.reveal();
            },
            { threshold: revealThresholds }
          );
          this.revealObserver.observe(this.stage || this);
        } else {
          this.isVisible = true;
          this.loadSelection();
        }
      }

      disconnectedCallback() {
        this.events?.abort();
        this.viewerEvents?.abort();
        this.loadObserver?.disconnect();
        this.revealObserver?.disconnect();
        window.clearTimeout(this.modelTimeout);
        window.clearInterval(this.loadedPoll);
        this.cancelIntro();
        this.requestId = (this.requestId || 0) + 1;
      }

      setState(state, message) {
        window.clearTimeout(this.modelTimeout);
        this.dataset.state = state;
        this.viewer.setAttribute('aria-busy', String(state === 'loading'));
        this.retryButton.hidden = state !== 'error';
        this.status.textContent = message;
      }

      cancelCameraIntro() {
        this.introAborted = true;
        window.cancelAnimationFrame(this.introFrame);
        window.clearTimeout(this.introResetTimer);

        if (this.introDecay !== undefined) {
          if (this.introDecay === null) this.viewer.removeAttribute('interpolation-decay');
          else this.viewer.setAttribute('interpolation-decay', this.introDecay);
          this.introDecay = undefined;
        }
      }

      cancelIntro() {
        this.introEvents?.abort();
        this.viewer?.classList.remove('is-intro');
        this.cancelCameraIntro();
      }

      animateIntroOrbit(from, to, requestId, onComplete) {
        const viewer = this.viewer;
        const { signal } = this.introEvents;
        const isCurrent = () =>
          !this.introAborted && !signal.aborted && this.isConnected && requestId === this.requestId;
        let startedAt;

        const tick = async (now) => {
          if (!isCurrent()) return;
          startedAt ??= now;
          const progress = Math.min((now - startedAt) / INTRO_ROTATION_DURATION, 1);
          const eased = (1 - Math.cos(Math.PI * progress)) / 2;
          const angle = from + (to - from) * eased;
          viewer.setAttribute('camera-orbit', `${angle}deg 84deg auto`);
          await viewer.updateComplete;
          if (!isCurrent()) return;
          viewer.jumpCameraToGoal?.();

          if (progress < 1) this.introFrame = window.requestAnimationFrame(tick);
          else onComplete();
        };

        if (isCurrent()) this.introFrame = window.requestAnimationFrame(tick);
      }

      playIntro(requestId) {
        if (this.introTouched) return;

        this.introAborted = false;
        this.introDecay = this.viewer.getAttribute('interpolation-decay');
        this.viewer.setAttribute('interpolation-decay', '0');

        const yieldCamera = () => this.cancelCameraIntro();
        this.viewer.addEventListener('pointerdown', yieldCamera, { once: true, signal: this.introEvents.signal });
        this.viewer.addEventListener('wheel', yieldCamera, {
          once: true,
          passive: true,
          signal: this.introEvents.signal,
        });

        this.animateIntroOrbit(parseFloat(INTRO_ORBIT.start), parseFloat(INTRO_ORBIT.turn), requestId, () => {
          this.introResetTimer = window.setTimeout(() => {
            this.animateIntroOrbit(parseFloat(INTRO_ORBIT.turn), parseFloat(INTRO_ORBIT.end), requestId, () => {
              this.cancelIntro();
            });
          }, INTRO_ROTATION_PAUSE);
        });
      }

      reveal() {
        if (this.dataset.state === 'ready') return;

        this.pendingReveal = false;

        if (this.introPlayed || window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) {
          this.setState('ready', '');
          return;
        }

        this.introPlayed = true;
        this.introTouched = false;

        const viewer = this.viewer;
        const requestId = this.requestId;
        this.introEvents = new AbortController();
        const markTouched = () => {
          this.introTouched = true;
        };
        viewer.addEventListener('pointerdown', markTouched, { once: true, signal: this.introEvents.signal });
        viewer.addEventListener('wheel', markTouched, {
          once: true,
          passive: true,
          signal: this.introEvents.signal,
        });
        const onIntroEnd = (event) => {
          if (event.target !== viewer || event.animationName !== 'note-one-model-enter') return;
          if (!this.isConnected || requestId !== this.requestId) return;
          viewer.removeEventListener('animationend', onIntroEnd);
          viewer.classList.remove('is-intro');
          this.playIntro(requestId);
        };
        viewer.addEventListener('animationend', onIntroEnd, { signal: this.introEvents.signal });
        viewer.classList.add('is-intro');
        this.setState('ready', '');
      }

      select(color) {
        if (!this.colors?.includes(color)) return;

        this.colors.forEach((item) => {
          const active = item === color;
          item.setAttribute('aria-checked', String(active));
          item.tabIndex = active ? 0 : -1;
        });

        if (color.dataset.modelSrc !== this.viewer.getAttribute('src')) this.loadSelection();
      }

      onKeydown(event) {
        if (!this.colors?.length) return;

        const color = event.target.closest?.('.note-one-page-model__color');
        if (!color) return;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.select(color);
          return;
        }

        const direction = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
        let nextIndex;

        if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.colors.length - 1;
        else if (direction) {
          const current = this.colors.indexOf(color);
          nextIndex = (current + direction + this.colors.length) % this.colors.length;
        } else return;

        event.preventDefault();
        const next = this.colors[nextIndex];
        this.select(next);
        next.focus();
      }

      async loadSelection() {
        this.loadObserver?.disconnect();
        this.viewerEvents?.abort();
        window.clearInterval(this.loadedPoll);
        this.cancelIntro();
        this.pendingReveal = false;
        const requestId = (this.requestId = (this.requestId || 0) + 1);
        const selected = this.colors?.find((color) => color.getAttribute('aria-checked') === 'true');
        const src = selected?.dataset.modelSrc;
        const color = selected?.dataset.colorLabel || 'Note ONE';

        if (!src) {
          this.setState('error', 'No 3D model is available for this color.');
          return;
        }

        this.setState('loading', 'Loading 3D model…');

        try {
          await loadModelViewer();
          if (!this.isConnected || requestId !== this.requestId) return;

          const viewer = this.viewer;
          this.viewerEvents = new AbortController();
          const { signal } = this.viewerEvents;
          const markReady = () => {
            if (requestId !== this.requestId || this.readyRequest === requestId) return;
            this.readyRequest = requestId;
            window.clearInterval(this.loadedPoll);

            if (this.isVisible) {
              this.reveal();
            } else {
              this.pendingReveal = true;
              this.setState('loaded', '');
            }
          };

          this.loadedPoll = window.setInterval(() => {
            if (viewer.loaded) markReady();
          }, 400);

          viewer.setAttribute('alt', `UMEVO Note ONE — ${color} 3D model`);
          viewer.addEventListener('load', markReady, { signal });
          viewer.addEventListener(
            'progress',
            (event) => {
              if ((event.detail?.totalProgress ?? 0) >= 1) markReady();
            },
            { signal }
          );
          viewer.addEventListener(
            'error',
            () => {
              if (requestId === this.requestId) {
                this.setState('error', 'Unable to load the 3D model. Please try again.');
              }
            },
            { signal }
          );

          this.modelTimeout = window.setTimeout(() => {
            if (requestId !== this.requestId) return;
            if (viewer.loaded) markReady();
            else this.setState('error', 'The 3D model is taking too long to load. Please try again.');
          }, 20000);

          viewer.setAttribute('src', src);
        } catch (error) {
          if (this.isConnected && requestId === this.requestId) {
            this.setState('error', 'Unable to load the 3D viewer. Please try again.');
          }
        }
      }
    }

    customElements.define('note-one-page-model', NoteOnePageModel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["note-one-page-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('note-one-page-video')) return;

    /* One frame at 30fps: smaller scroll deltas reuse the frame already painted. */
    const FRAME_STEP = 1 / 30;
    const LOAD_TIMEOUT = 20000;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    class NoteOnePageVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.stage = this.querySelector('[data-stage]');
        this.viewport = this.querySelector('[data-viewport]');
        this.frame = this.querySelector('[data-frame]');
        this.feedback = this.querySelector('[data-feedback]');
        this.status = this.querySelector('[data-status]');
        this.retryButton = this.querySelector('[data-retry]');
        if (!this.video || !this.stage || !this.viewport || !this.frame || !this.feedback) return;

        const video = this.video;
        this.events = new AbortController();
        const { signal } = this.events;

        this.duration = 0;
        this.targetTime = null;
        this.inView = false;
        this.rafId = 0;

        video.pause();
        video.muted = true;
        this.setLoading();

        video.addEventListener('loadedmetadata', () => this.onMetadata(), { signal });
        video.addEventListener('loadeddata', () => this.onReady(), { signal });
        video.addEventListener('error', () => this.fail('Unable to load the video. Please try again.'), { signal });
        video.addEventListener('seeked', () => this.onSeeked(), { signal });
        this.retryButton?.addEventListener('click', () => this.reload(), { signal });

        this.reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
        this.scrubEnabled = null;

        window.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
        window.addEventListener(
          'resize',
          () => {
            this.measure();
            this.schedule();
          },
          { signal }
        );
        this.reducedMotion?.addEventListener?.('change', () => this.syncMode(), { signal });

        this.syncMode();

        if ('IntersectionObserver' in window) {
          this.loadObserver = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.loadObserver?.disconnect();
              this.loadObserver = null;
              this.startLoading();
            },
            { rootMargin: '800px 0px' }
          );
          this.loadObserver.observe(this);

          this.viewObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[entries.length - 1];
              if (!entry) return;
              this.inView = entry.isIntersecting;
              if (this.inView) this.schedule();
            },
            { rootMargin: '120px 0px' }
          );
          this.viewObserver.observe(this.stage);
        } else {
          this.inView = true;
          this.startLoading();
        }

        if (video.readyState >= 1) this.onMetadata();
        if (video.readyState >= 2) this.onReady();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.loadObserver?.disconnect();
        this.viewObserver?.disconnect();
        window.clearTimeout(this.loadTimeout);
        window.cancelAnimationFrame(this.rafId);
        this.rafId = 0;
      }

      canScrub() {
        return !this.reducedMotion?.matches;
      }

      syncMode() {
        const scrubEnabled = this.canScrub();
        if (scrubEnabled === this.scrubEnabled) return;
        this.scrubEnabled = scrubEnabled;

        const video = this.video;
        this.dataset.mode = scrubEnabled ? 'scrub' : 'static';

        if (!video) return;

        if (scrubEnabled) {
          video.pause();
          video.controls = false;
          video.setAttribute('tabindex', '-1');
          this.measure();
          this.schedule();
          return;
        }

        video.controls = true;
        video.removeAttribute('tabindex');
      }

      watchLoad() {
        window.clearTimeout(this.loadTimeout);
        this.loadTimeout = window.setTimeout(() => {
          if (this.dataset.state !== 'ready') {
            this.fail('The video is taking too long to load. Please try again.');
          }
        }, LOAD_TIMEOUT);
      }

      setState(state, message) {
        this.dataset.state = state;
        if (this.retryButton) this.retryButton.hidden = state !== 'error';
        if (this.status) this.status.textContent = message || '';
      }

      setLoading() {
        this.setState('loading', 'Loading…');
      }

      startLoading() {
        const video = this.video;
        if (!video || video.preload === 'auto') return;
        video.preload = 'auto';
        this.watchLoad();
        video.load();
      }

      reload() {
        const video = this.video;
        if (!video) return;

        this.duration = 0;
        this.targetTime = null;
        this.primed = false;
        this.dataset.mode = this.scrubEnabled ? 'scrub' : 'static';
        this.setLoading();
        this.watchLoad();
        video.load();
      }

      fail(message) {
        window.clearTimeout(this.loadTimeout);
        /* Collapse the scroll track so a broken video does not leave a tall empty section. */
        this.dataset.mode = 'static';
        this.setState('error', message);
      }

      onMetadata() {
        const video = this.video;
        if (!video) return;

        const { duration } = video;
        if (!Number.isFinite(duration) || duration <= 0) return;
        if (this.duration === duration) return;

        this.duration = duration;
        try {
          video.currentTime = Math.min(0.001, duration);
        } catch (error) {
          /* Some browsers refuse an early seek; the first frame paints on load. */
        }
        this.schedule();
      }

      onReady() {
        if (this.dataset.state === 'ready') return;

        window.clearTimeout(this.loadTimeout);
        this.setState('ready', '');

        if (!this.scrubEnabled) return;
        this.dataset.mode = 'scrub';
        this.prime();
        this.schedule();
      }

      /* Safari only decodes seeked frames reliably once playback has been initialised. */
      prime() {
        const video = this.video;
        if (!video || this.primed) return;
        this.primed = true;

        try {
          const attempt = video.play();
          if (attempt && typeof attempt.then === 'function') {
            attempt.then(() => video.pause()).catch(() => {});
          }
        } catch (error) {
          /* Autoplay may be blocked; scrubbing still works on most browsers. */
        }
      }

      measure() {
        /* Read the layout once per resize: is the viewport pinned, and from which offset? */
        const styles = window.getComputedStyle(this.viewport);
        this.stickyTop = Number.parseFloat(styles.top) || 0;
        this.pinned = styles.position === 'sticky';
      }

      schedule() {
        if (!this.scrubEnabled || this.rafId) return;
        this.rafId = window.requestAnimationFrame(() => {
          this.rafId = 0;
          this.update();
        });
      }

      update() {
        if (!this.duration || !this.inView) return;

        const stageRect = this.stage.getBoundingClientRect();
        const scrollY = window.scrollY || 0;
        const stageTop = stageRect.top + scrollY;
        const cardHeight = this.frame.offsetHeight;

        let start;
        let end;

        if (this.pinned) {
          /* Pinned: the card is half way into the viewport until the stage track is used up. */
          const viewHeight = this.viewport.offsetHeight;
          const cardOffset = Math.max(0, (viewHeight - cardHeight) / 2);
          start = stageTop + cardOffset - window.innerHeight + cardHeight / 2;
          end = stageTop + stageRect.height - this.stickyTop - viewHeight;
        } else {
          /* Unpinned (mobile): the card's pass through the viewport drives playback. */
          start = stageTop - window.innerHeight;
          end = stageTop + cardHeight;
        }

        if (!(end > start)) return;

        const progress = clamp((scrollY - start) / (end - start), 0, 1);
        this.targetTime = progress * Math.max(0, this.duration - 0.08);
        this.seek(this.targetTime);
      }

      seek(time) {
        const video = this.video;
        if (!video || video.readyState < 1 || video.seeking) return;
        if (Math.abs(video.currentTime - time) < FRAME_STEP / 2) return;

        try {
          video.currentTime = time;
        } catch (error) {
          /* Ignore seeks issued while the element is still settling. */
        }
      }

      onSeeked() {
        if (!this.scrubEnabled || this.targetTime == null) return;
        if (Math.abs(this.video.currentTime - this.targetTime) > FRAME_STEP / 2) this.seek(this.targetTime);
      }
    }

    customElements.define('note-one-page-video', NoteOnePageVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["online-resellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SITE = {
      businessEmail: '',
      emailLabel: 'Business email to be confirmed',
    };

    var arrowSvg = '<svg class="arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>';

    function showToast(message) {
      var toast = document.querySelector('.toast');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(window.__toastTimer);
      window.__toastTimer = setTimeout(function () {
        toast.classList.remove('show');
      }, 3200);
    }

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard
          .writeText(text)
          .then(function () {
            return true;
          })
          .catch(function () {
            return fallbackCopy(text);
          });
      }
      return Promise.resolve(fallbackCopy(text));
    }

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      var ok = document.execCommand('copy');
      textarea.remove();
      return ok;
    }

    function initMailButtons() {
      document.querySelectorAll('[data-email-label]').forEach(function (el) {
        el.textContent = SITE.businessEmail || SITE.emailLabel;
      });

      document.querySelectorAll('.js-mail').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var subject = button.dataset.subject || '[Online Reseller] Company | Website';
          if (SITE.businessEmail) {
            window.location.href = 'mailto:' + SITE.businessEmail + '?subject=' + encodeURIComponent(subject);
            return;
          }
          copyText(subject).then(function () {
            showToast('The business email is not configured yet. The suggested subject has been copied.');
          });
        });
      });

      document.querySelectorAll('.js-copy-subject').forEach(function (button) {
        button.addEventListener('click', function () {
          copyText(button.dataset.subject || '').then(function () {
            showToast('Suggested email subject copied.');
          });
        });
      });
    }

    function initFaq(prefix) {
      document.querySelectorAll('.faq-question').forEach(function (button, index) {
        var answer = button.nextElementSibling;
        var id = 'faq-answer-' + prefix + '-' + (index + 1);
        answer.id = id;
        button.setAttribute('aria-controls', id);
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', function () {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
        });
      });
    }

    function initReveal() {
      var items = document.querySelectorAll('.reveal');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('visible');
        });
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08 }
      );
      items.forEach(function (item) {
        observer.observe(item);
      });
    }

    function init() {
      initMailButtons();
      initFaq('or');
      initReveal();
      document.querySelectorAll('.button.with-arrow').forEach(function (button) {
        if (!button.querySelector('svg')) {
          button.insertAdjacentHTML('beforeend', arrowSvg);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-healthcare"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-use-cases-page="healthcare"]');
  if (!root || root.dataset.ucReady === 'true') return;
  root.dataset.ucReady = 'true';

  root.querySelectorAll('[role="tablist"]').forEach((list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(item.getAttribute('aria-controls') || ''));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - 20, behavior: 'smooth' });
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[next], true);
      });
    });
  });

  const dialog = root.querySelector('dialog');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('.dialog-caption');
  root.querySelectorAll('[data-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const source = button.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = button.dataset.caption || source.alt || '';
      if (caption) caption.textContent = button.dataset.caption || '';
      dialog.showModal();
    });
  });
  dialog.querySelector('.dialog-close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-ideas"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-use-cases-page="ideas"]');
  if (!root || root.dataset.ucReady === 'true') return;
  root.dataset.ucReady = 'true';

  root.querySelectorAll('[role="tablist"]').forEach((list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(item.getAttribute('aria-controls') || ''));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - 20, behavior: 'smooth' });
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[next], true);
      });
    });
  });

  const dialog = root.querySelector('dialog');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('.dialog-caption');
  root.querySelectorAll('[data-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const source = button.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = button.dataset.caption || source.alt || '';
      if (caption) caption.textContent = button.dataset.caption || '';
      dialog.showModal();
    });
  });
  dialog.querySelector('.dialog-close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-interviews"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-use-cases-page="interviews"]');
  if (!root || root.dataset.ucReady === 'true') return;
  root.dataset.ucReady = 'true';

  root.querySelectorAll('[role="tablist"]').forEach((list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(item.getAttribute('aria-controls') || ''));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - 20, behavior: 'smooth' });
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[next], true);
      });
    });
  });

  const dialog = root.querySelector('dialog');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('.dialog-caption');
  root.querySelectorAll('[data-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const source = button.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = button.dataset.caption || source.alt || '';
      if (caption) caption.textContent = button.dataset.caption || '';
      dialog.showModal();
    });
  });
  dialog.querySelector('.dialog-close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-lectures"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-use-cases-page="lectures"]');
  if (!root || root.dataset.ucReady === 'true') return;
  root.dataset.ucReady = 'true';

  root.querySelectorAll('[role="tablist"]').forEach((list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(item.getAttribute('aria-controls') || ''));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - 20, behavior: 'smooth' });
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[next], true);
      });
    });
  });

  const dialog = root.querySelector('dialog');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('.dialog-caption');
  root.querySelectorAll('[data-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const source = button.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = button.dataset.caption || source.alt || '';
      if (caption) caption.textContent = button.dataset.caption || '';
      dialog.showModal();
    });
  });
  dialog.querySelector('.dialog-close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-legal"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-use-cases-page="legal"]');
  if (!root || root.dataset.ucReady === 'true') return;
  root.dataset.ucReady = 'true';

  root.querySelectorAll('[role="tablist"]').forEach((list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(item.getAttribute('aria-controls') || ''));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - 20, behavior: 'smooth' });
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[next], true);
      });
    });
  });

  const dialog = root.querySelector('dialog');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('.dialog-caption');
  root.querySelectorAll('[data-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const source = button.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = button.dataset.caption || source.alt || '';
      if (caption) caption.textContent = button.dataset.caption || '';
      dialog.showModal();
    });
  });
  dialog.querySelector('.dialog-close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-meetings"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-use-cases-page="meetings"]');
  if (!root || root.dataset.ucReady === 'true') return;
  root.dataset.ucReady = 'true';

  root.querySelectorAll('[role="tablist"]').forEach((list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(item.getAttribute('aria-controls') || ''));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - 20, behavior: 'smooth' });
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[next], true);
      });
    });
  });

  const dialog = root.querySelector('dialog');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('.dialog-caption');
  root.querySelectorAll('[data-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const source = button.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = button.dataset.caption || source.alt || '';
      if (caption) caption.textContent = button.dataset.caption || '';
      dialog.showModal();
    });
  });
  dialog.querySelector('.dialog-close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-phone-calls"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-use-cases-page="phone-calls"]');
  if (!root || root.dataset.ucReady === 'true') return;
  root.dataset.ucReady = 'true';

  root.querySelectorAll('[role="tablist"]').forEach((list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(item.getAttribute('aria-controls') || ''));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - 20, behavior: 'smooth' });
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[next], true);
      });
    });
  });

  const dialog = root.querySelector('dialog');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('.dialog-caption');
  root.querySelectorAll('[data-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const source = button.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = button.dataset.caption || source.alt || '';
      if (caption) caption.textContent = button.dataset.caption || '';
      dialog.showModal();
    });
  });
  dialog.querySelector('.dialog-close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-sales"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-use-cases-page="sales"]');
  if (!root || root.dataset.ucReady === 'true') return;
  root.dataset.ucReady = 'true';

  root.querySelectorAll('[role="tablist"]').forEach((list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(item.getAttribute('aria-controls') || ''));
        if (panel) panel.hidden = !active;
      });
      if (focus) tab.focus();
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - 20, behavior: 'smooth' });
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[next], true);
      });
    });
  });

  const dialog = root.querySelector('dialog');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('.dialog-caption');
  root.querySelectorAll('[data-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const source = button.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = button.dataset.caption || source.alt || '';
      if (caption) caption.textContent = button.dataset.caption || '';
      dialog.showModal();
    });
  });
  dialog.querySelector('.dialog-close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
